import { request } from "@/utils/request";

/**
 * 上传文件
 * @param file 
 * @returns 
 */
export function uploadFile(file) {
  const form = new FormData()
  form.append('file', file)
  return request({
      url: '/appeditor/file/upload',
      method: 'post',
      data: form
  })
}

/**
 * 根据文件ID下载文件
 * @param {*} fileId 
 * @returns 
 */
export function downloadFile(fileId) {
  return request({
    url: '/appeditor/file/download',
    method: 'get',
    params: { fileId },
    responseType: 'blob'
  })
}

/**
 * 获取文件下载地址
 * @param {*} fileId 
 * @returns 
 */
export function getDownloadUrl(fileId) {
  return `${process.env.VUE_APP_API_BASE_URL}/appeditor/file/download?fileId=${fileId}`
} 

/**
 * 保存blob数据到本地
 * @param {*} blob 
 * @param {*} filename 
 */
export function saveBlob(blob, filename) {
  const link = document.createElement("a");
  const body = document.querySelector("body");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;

  // fix Firefox
  link.style.display = "none";
  body.appendChild(link);

  link.click();
  body.removeChild(link);

  window.URL.revokeObjectURL(link.href);
}